import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import './style.scss';

const GroupedContentThemeDetail = ({ onLoadMore, pager, loading, entities, ...props }) => {
  const className = 'col-12 col-md-4 GroupedContentThemeDetail__item-wrapper';
  return (
    <div className="View GroupedContentThemeDetail">
      <div className="row no-gutters">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GroupedContentThemeDetail;
